import { render, staticRenderFns } from "./Loginlocal.vue?vue&type=template&id=554953b6&scoped=true"
import script from "./Loginlocal.vue?vue&type=script&lang=js"
export * from "./Loginlocal.vue?vue&type=script&lang=js"
import style0 from "./Loginlocal.vue?vue&type=style&index=0&id=554953b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554953b6",
  null
  
)

export default component.exports